module.exports = __webpack_public_path__ + "d377f3ebddbc3f836f081875e25ae7ae.png";